export default __webpack_public_path__ + "static/media/neutral.14f337a7.svg";